import React, { Fragment, useState } from 'react';
// import { Row, Col, Table, Card, Form, Input, DatePicker, Select, Button } from 'antd';
import DataEntry from '../delivery_data_entry';

const isEditting = true;

export default function DetailsPage(props){
    const [deliveryDetails] = useState(props);

    return(
        <div>
            <DataEntry 
                deliveryDetails={deliveryDetails.location.state.record} 
                isEditting={isEditting}
            />
        </div>
    );
}